export const GENDER_OPTIONS = [
  { value: "woman", label: "Woman" },
  { value: "man", label: "Man" },
  { value: "non_binary", label: "Non-binary" },
  { value: "two_spirit", label: "Two-Spirit" },
  { value: "genderqueer_genderfluid", label: "Genderqueer/Genderfluid" },
  { value: "agender", label: "Agender" },
  {
    value: "another_identity",
    label: "Another identity / Self-describe",
  },
  { value: "prefer_not_to_say", label: "Prefer not to say" },
];

export const ETHNICITY_OPTIONS = [
  { value: "black_african_descent", label: "Black or African descent" },
  { value: "east_asian", label: "East Asian" },
  { value: "south_asian", label: "South Asian" },
  { value: "southeast_asian", label: "Southeast Asian" },
  {
    value: "indigenous_first_nations_metis_inuit",
    label: "Indigenous / First Nations / Metis / Inuit",
  },
  { value: "hispanic_latino", label: "Hispanic or Latino/a/x" },
  {
    value: "middle_eastern_north_african",
    label: "Middle Eastern or North African",
  },
  { value: "white_european_descent", label: "White / European descent" },
  { value: "mixed_multiracial", label: "Mixed / Multiracial" },
  { value: "prefer_not_to_say", label: "Prefer not to say" },
];

export const SELF_DESCRIBE = "another_identity";
export const PREFER_NOT_TO_SAY = "prefer_not_to_say";

export const DEMOGRAPHIC_VISIBILITY_FIELDS = {
  genderIdentities: "genderVisible",
  ethnicities: "ethnicityVisible",
  disabilityStatuses: "disabilityVisible",
  lgbtqIdentities: "lgbtqVisible",
};

export const DEMOGRAPHIC_ANSWER_FIELDS_BY_VISIBILITY = Object.fromEntries(
  Object.entries(DEMOGRAPHIC_VISIBILITY_FIELDS).map(
    ([answerField, visibilityField]) => [visibilityField, answerField],
  ),
);

const LEGACY_GENDER_ALIASES = {
  female: "woman",
  male: "man",
  "non-binary": "non_binary",
  "two-spirit": "two_spirit",
  genderfluid: "genderqueer_genderfluid",
  other: SELF_DESCRIBE,
  "prefer not to say": PREFER_NOT_TO_SAY,
};

const optionLabel = (options, value) =>
  options.find((option) => option.value === value)?.label;

export const normalizeGenderIdentities = (identities = []) => [
  ...new Set(
    (identities ?? []).map(
      (identity) => LEGACY_GENDER_ALIASES[identity] ?? identity,
    ),
  ),
];

export const toggleDemographicValue = (values, option) => {
  if (option === PREFER_NOT_TO_SAY) {
    return values.includes(option) ? [] : [option];
  }

  const withoutPrefer = values.filter((value) => value !== PREFER_NOT_TO_SAY);
  return withoutPrefer.includes(option)
    ? withoutPrefer.filter((value) => value !== option)
    : [...withoutPrefer, option];
};

export const formatGenderIdentity = (value, customGender) => {
  const canonical = LEGACY_GENDER_ALIASES[value] ?? value;
  if (canonical === SELF_DESCRIBE && customGender?.trim()) {
    return customGender.trim();
  }
  return optionLabel(GENDER_OPTIONS, canonical) ?? value;
};

export const formatEthnicity = (value, customEthnicity) => {
  if (value === "other" && customEthnicity?.trim()) {
    return customEthnicity.trim();
  }
  return optionLabel(ETHNICITY_OPTIONS, value) ?? value;
};

export const formatCommunityAnswer = (value) => {
  const normalized = value?.toLowerCase();
  if (normalized === "yes") return "Yes";
  if (normalized === "no") return "No";
  if ([PREFER_NOT_TO_SAY, "prefer not to say"].includes(normalized)) {
    return "Prefer not to say";
  }
  return value || "Skipped";
};

export const formatDisabilityAnswer = (value) => {
  const normalized = value?.toLowerCase();
  if (normalized === "yes") return "Yes, I have a disability";
  if (normalized === "no") return "No, I don't have a disability";
  if ([PREFER_NOT_TO_SAY, "prefer not to say"].includes(normalized)) {
    return "Prefer not to say";
  }
  return value || "Skipped";
};

export const isKnownGenderLabel = (value) => {
  const normalized = value.toLowerCase().replace(/[^a-z0-9]/g, "");
  return GENDER_OPTIONS.some(
    ({ label }) => label.toLowerCase().replace(/[^a-z0-9]/g, "") === normalized,
  );
};
